import { MAX_FILE_SIZE } from '@/app/(dashboard)/constants'
import DnDZone from '@/app/core/components/DndZone'
import { useDropzone } from 'react-dropzone'

export type PickFileProps = {
  onFileSelected: (file: File) => void
}

export const PickFile = ({ onFileSelected }: PickFileProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles, rejectedFiles) => {
      const file = rejectedFiles[0]?.file || acceptedFiles[0]

      if (file) {
        onFileSelected(file)
      }
    },
    accept: {
      'application/pdf': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        [],
    },
    maxSize: MAX_FILE_SIZE,
    multiple: false,
    noClick: false,
  })

  return (
    <DnDZone
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      isDragActive={isDragActive}
      className='tw-px-4 tw-pb-2 tw-pt-0 tw-space-y-2'
    >
      <p className='tw-text-neutral-500 tw-text-xs tw-text-center'>
        Allowed filetypes: .pdf, .doc, .docx
        <br />
        with max 3000 pages and max size of 500MB.
      </p>
    </DnDZone>
  )
}
